import addiesaas from '~/addiesaas'
import thumbnailsService from '../services/thumbnails-service'

const STORE_NS = 'ThumbnailGenerator/ThumbnailGenerator'

class ThumbnailGeneratorRequestWorker {
    constructor() {
        setInterval(() => {
            const ids = storeGet(`${STORE_NS}/requestThumbnailSetIds`)

            if (!ids.length) {
                return
            }

            thumbnailsService.request(ids).then(r => {
                r.data.forEach(t => {
                    storeDispatch(`${STORE_NS}/updateThumbnailSet`, t)
                    if (!t.thumbnails[0].requested) {
                        storeDispatch(`${STORE_NS}/removeRequestThumbnailSetId`, t.id)
                    }
                })
            })
        }, 5000)
    }
}

const storeGet = (path) => {
    return addiesaas.store.getters[path]
}
const storeDispatch = (path, payload) => {
    addiesaas.store.dispatch(path, payload)
}

new ThumbnailGeneratorRequestWorker()
